import React, { Component } from 'react';
import Product from './Product';

class Products extends Component {
  render() {
    let elementIndex = -1
    let shirts = this.props.shirts.map((product) => {
      elementIndex += 1;
      return (
        <Product
          Index={elementIndex}
          addVariantToCart={this.props.addVariantToCart}
          client={this.props.client}
          key={product.id.toString()}
          category="clyde-mays-shirts"
          product={product}
          products={this.props.shirts}
        />
      );
    });

    elementIndex = -1
    let hats = this.props.hats.map((product) => {
      elementIndex += 1;
      return (
        <Product
          Index={elementIndex}
          addVariantToCart={this.props.addVariantToCart}
          client={this.props.client}
          category="clyde-mays-hats"
          key={product.id.toString()}
          product={product}
          products={this.props.hats}
        />
      );
    });

    elementIndex = -1
    let accessarries = this.props.accessarries.map((product) => {
      elementIndex += 1;
      return (
        <Product
          Index={elementIndex}
          addVariantToCart={this.props.addVariantToCart}
          client={this.props.client}
          category="clyde-mays-accessarries"
          key={product.id.toString()}
          product={product}
          products={this.props.accessarries}
        />
      );
    });
    return (
      <div >
        <div className="Product_section">
          <h1>Próspero Tequila Merchandise</h1>
          <div className="product_breadcrumb">
            <h5 align="center">
              <a href="#HATS">HATS</a>-
              <a href="#SHIRTS">SHIRTS</a> -
              <a href="#ACCESSORIES">ACCESSORIES</a>
            </h5>
          </div>
        </div>
        <div className="container-fluid">
          <div className="Product_page">


            <div className="row" id="HATS">
            </div>
            <div className="row pt-4">
              {hats}
            </div>
            <div className="row" id="SHIRTS" style={{ borderBottom: "1px solid white" }}>
              <h4 className="header-product">PRÓSPERO Shirts Collection</h4>
            </div>
            <div className="row pt-4">
              {shirts}
            </div>
            <div className="row" id="ACCESSORIES" style={{ borderBottom: "1px solid white" }}>
              <h4 className="header-product">PRÓSPERO Accessories</h4>
            </div>
            <div className="row pt-4">
              {accessarries}
            </div>
          </div>
        </div>
        <footer className="footer">
          <div className="container-fluid">

            <section className="footer__main">
              <div className="footer__inner">
                <nav className="footer__nav new-ff">
                  <ul>
                    <li className=""><a href="https://www.prosperotequila.com/#about">OUR CULTURE</a></li>
                    <li className=""><a href="https://www.prosperotequila.com/#product">EXPRESSIONS</a></li>
                    <li className=""><a href="https://www.prosperotequila.com/#women">WOMEN OF PRÓSPERO</a></li>
                    <li className=""><a href="https://www.prosperotequila.com/#gallery">GALLERY</a></li>
                    <li className=""><a href="https://www.prosperotequila.com/pressandmedia/">PRESS</a></li>
                    <li className=""><a href="https://www.prosperotequila.com/locator">LOCATOR</a></li>
                    <li className=""><a href="https://www.prosperotequila.com/#contact">CONTACT</a></li>
                    <li className=""><a href="https://www.prosperotequila.com/buyonlineorinstore/">BUY NOW</a></li>
                  </ul>
                </nav>

                {/* <div className="footer__extended-nav"> */}
                {/* <div className="footer__logo">
                  <img src="https://www.prosperotequila.com/wp-content/uploads/2019/03/horse-header-3.png" alt="" style={{maxWidth: 150}}/>
                </div> */}

                {/* <div className="footer__nav--secondary">
                  <ul>

                    <li className="level__1"> */}
                {/* <ul className="children">
                        <li className="nav-category">Products</li>
                        <li>
                          <a href="https://clydemays.com/products/clyde-mays-straight-rye.html"> Straight Rye</a>
                        </li>
                        <li>
                          <a href="https://clydemays.com/products/cask-strength.html"> Cask Strength</a>
                        </li>
                        <li>
                          <a href="https://clydemays.com/products/special-reserve.html"> Special Reserve</a>
                        </li>
                        <li>
                          <a href="https://clydemays.com/products/alabama-style-whiskey.html"> Alabama Style™</a>
                        </li>
                        <li>
                          <a href="https://clydemays.com/products/straight-bourbon.html"> Straight Bourbon</a>
                        </li>
                      </ul> */}
                {/* </li>

                    <li className="level__1"> */}
                {/* <ul className="children">
                        <li className="nav-category">Contact</li>
                        <li>
                          <a className="email" href="mailto:Hello@ClydeMays.com">Hello@ClydeMays.com</a>
                        </li>
                        <li className="address"><p><strong>Conecuh Brands, LLC</strong>&nbsp;<br /></p>
                          <p style={{lineHeight:"0px" , paddingTop:"10px" , border: "none"}}>1050 Franklin Ave, Suite 304</p>
                          <p style={{border: "none"}}>Garden City, NY 11530</p>
                          <p><a style={{lineHeight:"0px"}} href="http://www.conecuhbrands.com/clyde-repository/?eeFolder=Clyde-Mays&amp;eeFront=1" target="_blank" rel="noreferrer noopener">DISTRIBUTOR LOGIN</a></p>
                        </li>
                      </ul> */}
                {/* </li> */}

                {/* <li className="level__1">
                      <ul className="children">
                        <li className="nav-category">Our Company</li>
                        <li className=""><a href="https://www.prosperotequila.com/#about">OUR CULTURE</a></li>
                        <li className=""><a href="https://www.prosperotequila.com/#product">EXPRESSIONS</a></li>
                        <li className=""><a href="https://www.prosperotequila.com/#women">WOMEN OF PRÓSPERO</a></li>
                        <li className=""><a href="https://www.prosperotequila.com/#gallery">GALLERY</a></li>
                        <li className=""><a href="https://www.prosperotequila.com/pressandmedia/">PRESS</a></li>
                        <li className=""><a href="https://www.prosperotequila.com/locator">LOCATOR</a></li>
                        <li className=""><a href="https://www.prosperotequila.com/#contact">CONTACT</a></li>
                        <li className=""><a href="https://www.prosperotequila.com/buyonlineorinstore/">BUY NOW</a></li>
                      </ul>
                    </li> */}

                {/* </ul>
                </div>
              </div> */}


                <div className="footer__bottom f-New">
                  © 2021 Próspero Tequila. All Rights Reserved - PLEASE DRINK RESPONSIBLY - DISTRIBUTOR LOGIN - LEGAL - PRIVACY<br />
                  Próspero brought to you by Conecuh Brands<br />
                  Conecuh Brands, LLC 1050 Franklin Ave., Suite 304 Garden City, NY 11530

                </div>
              </div>


            </section>
            <div className="copyright-area">
              <div className="row">
                <div className="col-xl-12 col-lg-12 text-center ">
                  <div className="footer__bottom">
                    <ul>
                      <li>
                        <span>COPYRIGHT © 2017 PRÓSPERO</span>
                      </li>
                      <li>
                        <span>
                          PLEASE DRINK RESPONSIBLY YA’ RASCAL
                        </span>
                      </li>
                      <li>
                        <span>

                          <a href="https://clydemays.com/terms-of-use.html">LEGAL</a> | <a href="https://PRÓSPERO.com/privacy-policy.html">PRIVACY POLICY</a>
                        </span>
                      </li>
                    </ul>                  </div>
                </div>
              </div>
            </div>
          </div>

        </footer>

      </div>
    );
  }
}

export default Products;



// WEBPACK FOOTER //
// ./src/components/Products.js